/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SafetySubTypeDto } from '../../models/safety-sub-type-dto';

export interface GetSubTypes$Params {
}

export function getSubTypes(http: HttpClient, rootUrl: string, params?: GetSubTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SafetySubTypeDto>>> {
  const rb = new RequestBuilder(rootUrl, getSubTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SafetySubTypeDto>>;
    })
  );
}

getSubTypes.PATH = '/safeties/safety-sub-types';
